
import { useState } from "react";
import { MembershipForm } from "./adhesion/MembershipForm";
import { MembershipOptions } from "./adhesion/MembershipOptions";
import { HeroSection } from "./adhesion/HeroSection";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

export default function Adhesion() {
  const [showMembershipForm, setShowMembershipForm] = useState(false);
  const [selectedMembershipType, setSelectedMembershipType] = useState<"active" | "benefactor" | "donor" | null>(null);
  const [donationAmount, setDonationAmount] = useState<number>(0);

  const handleSelectMembershipType = (type: "active" | "benefactor" | "donor") => {
    setSelectedMembershipType(type);
    
    // Seulement afficher le formulaire et déclencher le défilement 
    // si ce n'est pas le type "donor" (pour permettre de modifier le montant)
    if (type !== "donor") {
      setShowMembershipForm(true);
      
      setTimeout(() => {
        document.getElementById("membership-form")?.scrollIntoView({ 
          behavior: "smooth", 
          block: "start" 
        });
      }, 100);
    } else {
      // Pour "donor", juste mettre à jour le type sans déclencher le défilement
      setShowMembershipForm(true);
    }
  };

  const heroContent = {
    title: "Rejoignez-nous !",
    description: "Soutenons les principes de Liberté, Egalité, Fraternité et Laïcité tout comme les valeurs fondamentales de la République française que sont la Solidarite, le Respect des droits de l'égalité devant la loi telles qu'elles sont fondées par la Déclaration des droits de l'Homme du du citoyen.",
    backgroundImage: "/lovable-uploads/7bd7eb79-3cf9-47b3-803d-49b683133dcb.png"
  };

  return (
    <div className="min-h-screen">
      <Header />
      <div className="min-h-screen bg-gradient-to-b from-[#FFFD4C] via-[#FFFD4C] to-[#F5E84A] pt-28">
        <HeroSection 
          title={heroContent.title}
          description={heroContent.description}
          backgroundImage={heroContent.backgroundImage}
        />

        <div className="container max-w-5xl py-2">
          {/* Show membership options immediately */}
          <div id="membership-options" className="mt-4 mb-6 transition-all duration-500 animate-fadeIn">
            <MembershipOptions 
              onSelectType={handleSelectMembershipType} 
              donationAmount={donationAmount}
              setDonationAmount={setDonationAmount}
              selectedType={selectedMembershipType}
            />
          </div>
          
          {showMembershipForm && (
            <div id="membership-form" className="mt-6 transition-all duration-500 animate-fadeIn">
              <MembershipForm 
                initialMembershipType={selectedMembershipType as "active" | "benefactor" | "donor"} 
                donationAmount={selectedMembershipType === "donor" ? donationAmount : undefined}
              />
            </div>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
}
